import React, { useEffect, useState } from "react";
import "../Css/Header.css";
import Logo from "../Assets/logo.png";
import logoColor from "../Assets/logoColor.png";
import { getProfile, getToken } from "../services/localStorageServices";
import { useDispatch, useSelector } from "react-redux";
import { setUserToken } from "../features/authSlice";
import { Badge, Button, Dropdown } from "antd";
import { DownOutlined } from "@ant-design/icons";
import { useCartContext } from "../context/addToCart";
import FlotingIcon from "./FlotingIcon";
import { FaRegUserCircle, FaUserCircle } from "react-icons/fa";
import { IoMdClose } from "react-icons/io";
import { RxHamburgerMenu } from "react-icons/rx";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { FaCartShopping } from "react-icons/fa6";

const Header = () => {
  const navigate = useNavigate();
  const { access_token } = getToken();
  const { token } = useSelector((state) => state.auth);
  const { profile } = getProfile();
  const dispatch = useDispatch();
  const { cartValue } = useCartContext();
  const [navActive, setNavActive] = useState(false);
  const location = useLocation();

  // ================ Check Is Navbar Scroll and Active =============

  const [active, setActive] = useState(false);

  const handleScroll = () => {
    if (window.scrollY >= 80) {
      setActive(true);
    } else {
      setActive(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    // Cleanup the event listener on unmount
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []); // Empty dependency array as we don't need to re-attach the listener on updates.

  const handleLogout = () => {
    sessionStorage.removeItem("access_token");
    sessionStorage.removeItem("profile");
    localStorage.clear();
    sessionStorage.clear();
    navigate("/");
  };

  useEffect(() => {
    dispatch(setUserToken({ token: access_token }));
  }, [access_token, dispatch]);

  const links = [
    {
      label: "Home",
      link: "/",
      sub: [],
    },
    {
      label: "Order",
      link: "/search",
      sub: [],
    },
    {
      label: "About",
      link: "#",
      sub: [
        {
          label: "About Us",
          link: "/best-diamonds-collection",
        },
        {
          label: "Why Us",
          link: "/diamond-wholesaler",
        },
        {
          label: "Gallery",
          link: "/fancy-color-diamonds",
        },
      ],
    },
    {
      label: "Products",
      link: "/order",
      sub: [
        {
          label: "Melee Diamonds",
          link: "/melee-diamonds",
        },
        {
          label: "Certified Melee Diamonds",
          link: "/certified-melee-diamonds",
        },
        {
          label: "Fancy Shape & Color",
          link: "/fancy-diamonds-with-different-shapes",
        },
        {
          label: "Black Diamonds",
          link: "/black-diamonds",
        },
        {
          label: "Certified Diamonds",
          link: "/certified-diamonds",
        },
        {
          label: "Custom & Special Orders",
          link: "/customized-diamonds",
        },
      ],
    },
    {
      label: "Certified",
      link: "https://sejalgems.in/",
      sub: [],
    },
    {
      label: "Education",
      link: "#",
      sub: [
        {
          label: "Education",
          link: "/natural-diamonds",
        },
        {
          label: "FAQ",
          link: "/calibrated-diamonds",
        },
        {
          label: "Blog",
          link: "/best-diamond-supplier",
        },
      ],
    },

    {
      label: "Exhibition",
      link: "/best-diamond-exhibition",
      sub: [],
    },
    {
      label: "Contact Us",
      link: "/best-diamond-dealer",
      sub: [],
    },
  ];

  useEffect(() => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
    setNavActive(false);
  }, [location]);

  return (
    <>
      <FlotingIcon />
      <div className={`navbar ${active ? "active" : "mt-3"}`}>
        <div className="container">
          <div className="nav-details">
            <Button
              className="toggle-button d-lg-none d-block"
              style={{
                background: "#fff",
                color: "#003754",
                height: "40px",
              }}
              onClick={() => setNavActive(true)}
            >
              <RxHamburgerMenu style={{ fontSize: "1.4rem" }} />
            </Button>
            <NavLink className="navbar-brand" to="/">
              <img src={active !== true ? Logo : logoColor} />
            </NavLink>
            <div
              className={`activebg ${navActive && "active"}`}
              onClick={() => setNavActive(false)}
            ></div>
            <div className={`navbar-collapse ${navActive && "active"}`}>
              <div className="scrollHeader">
                <NavLink className="navbar-brand" to="/">
                  <img src={logoColor} />
                </NavLink>
                <Button
                  onClick={() => setNavActive(false)}
                  className="bg-danger text-white"
                  icon={<IoMdClose />}
                />
              </div>

              <ul className="navbar-items">
                {links.map((val, index) =>
                  val.sub.length > 0 ? (
                    <Dropdown
                      key={index}
                      menu={{
                        items: val.sub.map((subItem) => ({
                          key: subItem.key,
                          label: subItem.label,
                          onClick: () => navigate(subItem.link),
                        })),
                      }}
                    >
                      <li className="nav-item" key={index}>
                        <a
                          className="nav-link"
                          onClick={(e) => e.preventDefault()}
                        >
                          {val.label}
                          <DownOutlined />
                        </a>
                      </li>
                    </Dropdown>
                  ) : val.label === "Order" ? (
                    profile.verify == "1" && (
                      <li className="nav-item" key={index}>
                        <NavLink className="nav-link" to={val.link}>
                          {val.label}
                        </NavLink>
                      </li>
                    )
                  ) : (
                    <li className="nav-item" key={index}>
                      <NavLink className="nav-link" to={val.link}>
                        {val.label}
                      </NavLink>
                    </li>
                  )
                )}
              </ul>
            </div>
            <div className="nav-login d-flex align-items-center">
              {token ? (
                <>
                  {" "}
                  <Dropdown
                    menu={{
                      items: [
                        profile.type === "user" && {
                          key: 1,
                          label: "Profile",
                          onClick: () => navigate("/profile"),
                        },
                        profile.type == "staff" || profile.type == "admin"
                          ? {
                              key: 1,
                              label: "Control Panel",
                              onClick: () => navigate("/admin-panel"),
                            }
                          : null,
                        {
                          key: 2,
                          label: "Log Out",
                          onClick: () => handleLogout(),
                        },
                      ],
                    }}
                  >
                    <div style={{ zIndex: 1 }}>
                      <a
                        className="nav-link d-none d-md-block"
                        onClick={(e) => e.preventDefault()}
                      >
                        <span style={{ whiteSpace: "nowrap" }}>
                          {profile.name?.split(" ")[0]}&nbsp;
                          {profile.name?.split(" ")[1]}&nbsp;<DownOutlined />
                        </span>
                        <br />
                        <span
                          style={{
                            fontSize: ".8rem",
                            color:
                              profile.verify == "1" ? "green" : "orangered",
                          }}
                        >
                          {profile.verify == "1" ? "Verfied" : "Guest"}
                        </span>
                      </a>
                      <Badge
                        className="d-flex d-md-none"
                        dot={true}
                        color={profile.verify == "1" ? "green" : "red"}
                      >
                        <a
                          className="nav-link"
                          onClick={(e) => e.preventDefault()}
                          style={{ fontSize: "1.2rem" }}
                        >
                          <FaUserCircle />
                        </a>
                      </Badge>
                    </div>
                  </Dropdown>
                  <NavLink to="/add-to-cart">
                    <Badge
                      className="cartIcon mx-3"
                      showZero
                      count={cartValue.length}
                    >
                      <FaCartShopping style={{ fontSize: "1.2rem" }} />
                    </Badge>
                  </NavLink>
                </>
              ) : (
                <>
                  <Button
                    icon={<FaRegUserCircle />}
                    onClick={() => navigate("/login")}
                    className="customButton d-none d-md-flex"
                  >
                    Login / Registration
                  </Button>
                  <Button
                    icon={<FaRegUserCircle />}
                    onClick={() => navigate("/login")}
                    className="customButton d-flex d-md-none"
                  >
                    Login
                  </Button>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Header;
